/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `gpt-4.1` - GPT_4_1
 * * `gpt-4o` - GPT_4O
 * * `claude-3-5-haiku-latest` - CLAUDE_3_5_SONNET
 * * `claude-3-7-sonnet-latest` - CLAUDE_3_7_SONNET
 * * `google-gla:gemini-2.5-flash-preview-04-17` - GEMINI_2_5_FLASH
 */
export enum AiModel {
  GPT_4_1 = 'gpt-4.1',
  GPT_4O = 'gpt-4o',
  CLAUDE_3_5_SONNET = 'claude-3-5-haiku-latest',
  CLAUDE_3_7_SONNET = 'claude-3-7-sonnet-latest',
  GEMINI_2_5_FLASH = 'google-gla:gemini-2.5-flash-preview-04-17',
}
